import { HTMLAttributes } from 'react';

export const DefaultElement = (props: {
  attributes: HTMLAttributes<unknown>;
  children: HTMLElement;
}) => <p {...props.attributes}>{props.children}</p>;
